module.exports = __webpack_public_path__ + "static/media/Ram Face 2c.7fae215d.svg";